import { ViewClaimResults } from 'all-in-one-shared-api';

interface Props extends Partial<Pick<ViewClaimResults, 'claimId' | 'referenceNo' | 'sequenceNo' | 'claimStatus'>> {
  path?: string;
}

export const getClaimPageUrl = ({ path, claimId, referenceNo, sequenceNo, claimStatus }: Props): string | undefined => {
  const _claimId = claimId || referenceNo;

  if (!_claimId) return;

  // Note(Anson Kan): apparently `claimId` is not unique, shortfall claims need `sequenceNo` and `claimStatus` as part of its identity
  const searchParams = new URLSearchParams();

  if (sequenceNo !== undefined) searchParams.append('sequenceNo', `${sequenceNo}`);
  if (claimStatus !== undefined) searchParams.append('claimStatus', claimStatus);

  return `/claims/${_claimId}${path ? `/${path}` : ''}?${searchParams.toString()}`;
};

export const getUploadDocPageUrl = ({
  path,
  claimId,
  referenceNo,
  sequenceNo,
  claimStatus,
}: Props): string | undefined => {
  const _claimId = claimId;

  if (!_claimId) return;

  // Note(Anson Kan): apparently `claimId` is not unique, shortfall claims need `sequenceNo` and `claimStatus` as part of its identity
  const searchParams = new URLSearchParams();
  if (sequenceNo !== undefined) searchParams.append('sequenceNo', `${sequenceNo}`);
  if (claimStatus !== undefined) searchParams.append('claimStatus', claimStatus);
  if (referenceNo !== undefined) searchParams.append('referenceNo', referenceNo);

  return `/claims/${_claimId}${path ? `/${path}` : ''}?${searchParams.toString()}`;
};
